import styles from "./permissioncheck.module.scss";
import { useTranslation } from "react-i18next";
import { useIsAuthorized } from "@src/rtk/hooks";
import { useGetUsersWhoamiQuery } from "@src/api/openapi/merchantApi";
import { useLocation } from "react-router-dom";
import config from "@config";
import { handlePKCE } from "@src/rtk/slices/authSlice";
import {
  AcContainer,
  AcRow,
  AcColumn,
  AcLoaderInline,
  AcHeading,
  AcRichContent,
} from "@asdf-atoms";
import { THEMES } from "@asdf-constants";
import clsx from "clsx";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";

const _CLASSES = {
  MAIN: "ac-page ac-page--fullscreen ac-page--eggwhite",
};
export const PermissionChecker = ({ children }) => {
  const { t } = useTranslation();
  const path = useLocation();
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthorized();
  const { data } = useGetUsersWhoamiQuery(null, {
    skip: !isAuthenticated,
  });
  useEffect(() => {
    if (!isAuthenticated && path.pathname !== "/authenticate") {
      dispatch(handlePKCE(`${config.pkce.accounts_uri}/ping`));
    }
  }, [isAuthenticated, dispatch]);
  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN);
  }, []);
  if (["/login", "/authenticate", "/"].includes(path.pathname)) return children;
  if (!data)
    return (
      <div className={`${getMainClassNames} ${styles.container}`}>
        <AcContainer fluid>
          <AcRow>
            <AcColumn xs={12}>
              <AcLoaderInline loading dense />
            </AcColumn>
          </AcRow>

          <AcRow>
            <AcColumn xs={12}>
              <AcHeading rank={2} theme={THEMES.DARK}>
                {t("verifying-session", "Verifying your session", {
                  ns: "loginPage",
                })}
              </AcHeading>
            </AcColumn>
          </AcRow>

          <AcRow>
            <AcColumn xs={12}>
              <AcRichContent
                content={`<p>${t("please-wait", "Please wait...", {
                  ns: "loginPage",
                })}</p>`}
              />
            </AcColumn>
          </AcRow>
        </AcContainer>
      </div>
    );
  if (
    typeof data?.data.merchant.status === "string" &&
    (data?.data.merchant.status === "blocked" ||
      data?.data.merchant.status === "suspended")
  )
    return (
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          <span>{t("common:no-access")}</span>
          <span>{t("common:no-access-page")}</span>
        </div>
      </div>
    );
  return children;
};
